import { GenericPipelineParameterMappingSource } from '@warebee/frontend/data-access-api-graphql';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import DatasetQuerySelector from '../../customQuery/DatasetQuerySelector';
import PipelineTemplateParameterEditorWrap, {
  PipelineTemplateParameterEditorWrapProps,
} from '../editors/PipelineTemplateParameterEditorWrap';
import PipelineTemplateParameterValueWrap, {
  PipelineTemplateParameterValueWrapProps,
} from '../editors/PipelineTemplateParameterValueWrap';
import { PipelineTemplateDescriptor } from './genericPipelineTemplate.type';

const usePipelineTemplateDescriptors = () => {
  const { t } = useTranslation('app');
  const desc: PipelineTemplateDescriptor[] = [
    {
      templateId: 'test-automation-template-export-dataset-query-state-machine',

      title: t`Export Dataset Query`,
      templateParameters: [
        {
          parameterId: 'datasetQueryId',
          title: t`Dataset Query Id`,
          defaultValue: {
            name: 'datasetQueryId',
            source: GenericPipelineParameterMappingSource.CONSTANT,
            value: null,
          },
          render: (props: PipelineTemplateParameterValueWrapProps) => (
            <PipelineTemplateParameterValueWrap {...props}>
              {props.value?.value}
            </PipelineTemplateParameterValueWrap>
          ),
          editor: (props: PipelineTemplateParameterEditorWrapProps) => (
            <PipelineTemplateParameterEditorWrap {...props}>
              <DatasetQuerySelector
                selectedId={props.value?.value}
                onChange={v => props.onChange({ ...props.value, value: v.id })}
              />
            </PipelineTemplateParameterEditorWrap>
          ),
        },
        {
          parameterId: 'datasetQueryParameters',
          title: t`Query Params`,
          defaultValue: {
            name: 'datasetQueryParameters',
            source: GenericPipelineParameterMappingSource.ARRAY_MAPPING,
            value: [],
            arrayMapping: [],
          },
          render: (props: PipelineTemplateParameterValueWrapProps) => (
            <PipelineTemplateParameterValueWrap {...props}>
              {props.value?.value}
            </PipelineTemplateParameterValueWrap>
          ),
          editor: PipelineTemplateParameterEditorWrap,
        },
      ],
    },
  ];

  return _.keyBy(desc, 'templateId');
};

export default usePipelineTemplateDescriptors;
